import { computed, defineComponent } from "vue";
import Icon from "@/components/ui/icon/Icon";
import { $t } from "@/services/i18n";
import { p } from "@/utils/props-builder";

interface DependencyState {
  isResolving: boolean;
  current: number;
  total: number;
  errors: string[];
}

const props = {
  state: p.$object<DependencyState>(),
};

export default defineComponent({
  name: "DependencyModal",
  props,
  setup(props) {
    const progress = computed(() =>
      props.state?.total && props.state.total > 0
        ? (props.state.current / props.state.total) * 100
        : 0
    );

    return () => (
      <div class="absolute inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div class="w-80 rounded-lg bg-card p-6 shadow-lg">
          <div class="mb-4 flex items-center gap-3">
            <Icon icon="lucide:loader-2" class="h-6 w-6 animate-spin text-primary" />
            <div>
              <h3 class="font-semibold">{$t("agents:templates.creating_dependencies")}</h3>
              <p class="text-sm text-muted-foreground">
                {$t("agents:templates.creating_dependencies_description")}
              </p>
            </div>
          </div>

          {/* Simple progress bar */}
          <div class="mb-2 h-2 w-full overflow-hidden rounded-full bg-muted">
            <div
              class="h-full bg-primary transition-all duration-300"
              style={{ width: `${progress.value}%` }}
            />
          </div>

          <p class="text-center text-sm text-muted-foreground">
            {props.state?.current ?? 0} / {props.state?.total ?? 0}
          </p>
        </div>
      </div>
    );
  },
});
